"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _useStyles = _interopRequireDefault(require("./useStyles"));

var _SocialIcons = _interopRequireDefault(require("../SocialIcons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DigitalProperties = function DigitalProperties(_ref) {
  var company = _ref.company,
      socials = _ref.socials,
      text = _ref.text;
  var classes = (0, _useStyles["default"])();
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 5,
    className: classes.wrapper,
    pt: 3,
    pb: 3
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    item: true,
    sm: 12,
    md: 8,
    spacing: 4
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    color: "inherit"
  }, company)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true
  }, text ? /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    color: "inherit"
  }, text) : null)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    className: classes.iconWrapper
  }, /*#__PURE__*/_react["default"].createElement(_SocialIcons["default"], {
    socials: socials
  })))));
};

DigitalProperties.defaultProps = {
  text: ''
};
DigitalProperties.propTypes = {
  company: _propTypes["default"].string.isRequired,
  socials: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  text: _propTypes["default"].node
};
var _default = DigitalProperties;
exports["default"] = _default;